import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';

import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModalManagerComponent } from 'app/modal/modalManager.component';
import { ModalService } from 'app/modal/modal.service';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule
  ],
  declarations: [
    ModalManagerComponent
  ],
  providers: [
    ModalService
  ],
  exports: [
    ModalManagerComponent
  ]
})
export class ModalModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/modal/modal.module.ts